import Sentry from '@/services/sentry'
import Util from '@/util'
import UserApi from '@/api/user'
import mixpanelUtils from '@/utils/mixpanel.utils'
import configs from '@/config'

// The old code navigated synchronously; never let a stalled session end hold
// the removed user on the page longer than this.
export const END_SESSION_TIMEOUT_MS = 5000

export default {
  // AHA2-364: the API unsets $email/$first_name/$last_name on the Mixpanel profile
  // during account removal. Deleting only the JS-readable cookie left the
  // server-set session alive, so the next page (accountRemovalURL is the
  // presenter home outside production) loaded authenticated and identify()
  // people.set the name and email straight back onto the profile ~6s later.
  // End the server session and reset Mixpanel BEFORE navigating away, so no
  // page after this one can re-identify the removed user.
  logOutAccountRemoval: async () => {
    try {
      await Promise.race([
        UserApi.endSession(),
        new Promise((resolve) => { setTimeout(resolve, END_SESSION_TIMEOUT_MS) }),
      ])
    } catch (error) {
      // The account is already gone: a failed session end must not strand the
      // user on the page, so report it and still leave.
      Sentry.captureException(error)
    }
    mixpanelUtils.reset()
    Util.deleteTokenCookie()
    Util.cleanUserCookies()
    window.location.href = configs.accountRemovalURL
  },
}
